import { render, staticRenderFns } from "./DetailItem.vue?vue&type=template&id=0ae779a2"
import script from "./DetailItem.vue?vue&type=script&lang=js"
export * from "./DetailItem.vue?vue&type=script&lang=js"
import style0 from "./DetailItem.vue?vue&type=style&index=0&id=0ae779a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports